<mat-dialog-actions align="end">
  <button ca-action-button mat-dialog-close><mat-icon>close</mat-icon></button>
</mat-dialog-actions>
<mat-dialog-content>
  <h1 mat-dialog-title>{{ "history.title" | translate }}</h1>
  @if (loading === true) {
    <div class="loading">
      <mat-spinner diameter="20"></mat-spinner>
      {{ "history.loading" | translate }}
    </div>
  }
  @if (loading === false && history.length > 0) {
    <div
      class="history"
      >
      @for (event of history | sortBy : 'created' : 'descending'; track event) {
        <ca-entity-history-item
          [event]="event"
      [trailing]="
        event.type === CREATED || event.type === UPDATED
          ? event.meta?.body
          : null
      "
          [member]="members[event.memberId]"
          >
        </ca-entity-history-item>
      }
    </div>
  } @else {
    @if (loading === false && history.length === 0) {
      <p>
        {{ "history.empty" | translate }}
      </p>
    }
  }
  <ng-template #empty>
    @if (loading === false && history.length === 0) {
      <p>
        {{ "history.empty" | translate }}
      </p>
    }
  </ng-template>
</mat-dialog-content>
